import { BodyType, Category, FuelType, Gear } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const SELECT_CATEGORY_TYPE = Object.keys(Category).map((type) => ({
  value: Category[type],
  display: <Text tId={Category[type]} />,
}));

export const SELECT_GEAR_TYPE = Object.keys(Gear).map((type) => ({
  value: Gear[type],
  display: <Text tId={Gear[type]} />,
}));

export const SELECT_BODY_TYPE = Object.keys(BodyType).map((type) => ({
  value: BodyType[type],
  display: <Text tId={BodyType[type]} />,
}));

export const SELECT_FUEL_TYPE = Object.keys(FuelType).map((type) => ({
  value: FuelType[type],
  display: <Text tId={FuelType[type]} />,
}));

export const SELECT_IS_NEW_VEHICLE = [
  {
    value: 'true',
    display: <Text tId={'YES'} />,
  },
  { value: 'false', display: <Text tId={'NO'} /> },
];
